import Immutable from 'immutable'
import moment from 'moment'

import createSignupStateTransition from './SignupStateTransition'

export const SignupRecord = Immutable.Record({
  abn: null,
  accessKey: '',
  address: '',
  addressLocId: '', // The address LOCID, if something was selected
  agreeTerms: false,
  billingGroupId: null,
  challengePhrase: null,
  clientId: null,
  companyName: null,
  companySize: null,
  contact: null,
  coupon: null, // Store coupon code
  creator: null,
  creatorIp: '',
  customerReference: '',
  data: Immutable.Map(),
  dateAdded: null,
  dateOfBirth: null,
  dateUpdated: null,
  email: '',
  emailConfirm: '', // Used only for front end double email confirmation
  extraOffer: null,
  firstName: '',
  lastName: '',
  firstPayment: 0,
  hasCoupon: false,
  hasServicePassword: false,
  hasUserPassword: false,
  id: null,
  lastTransition: null,
  minimumSpend: 0,
  offer: null,
  paidAmount: 0,
  partner: null,
  payments: Immutable.Set(),
  preferredAppointmentDate: null,
  preferredAppointmentTime: null,
  qualification: null,
  recurringAmount: 0,
  reference: '',
  requestId: '',
  servicePassword: null,
  setupAmount: 0,
  siteContactFirstName: null,
  siteContactLastName: null,
  siteContactNumber: null,
  siteId: null,
  state: 'new',
  stateTransitions: Immutable.OrderedSet(),
  token: null, // Store the UUID
  user: null,
  userAgent: '',
  userPassword: null, // This is not returned by the API, but used when writing a new Signup Account entry
}, 'Signup')

export const SignupWithExternalsRecord = Immutable.Record({
  billingGroup: null,
  client: null,
  coupon: null,
  creator: null,
  extraOffer: null,
  offer: null,
  signup: null,
  partner: null,
  payments: Immutable.Set(),
  product: null,
  token: null,
  user: null,
}, 'SignupWithExternals')

export default function createSignup({
  coupon,
  creator,
  data,
  dateAdded,
  dateOfBirth,
  dateUpdated,
  emailConfirm = '',
  lastTransition,
  partner,
  payments = [],
  preferredAppointmentDate,
  preferredAppointmentTime,
  qualification,
  stateTransitions = [],
  token,
  user,
  ...signup
}) {
  if (!emailConfirm && signup.id && signup.email) {
    emailConfirm = signup.email
  }

  stateTransitions = Immutable.OrderedSet(stateTransitions.map(st => createSignupStateTransition(st)))
    .sortBy(st => st.dateAdded.toDate())
    .reverse()

  return new SignupRecord({
    coupon: coupon ? coupon.code : null,
    creator: creator ? creator.id : null,
    data: Immutable.Map(data),
    dateAdded: dateAdded ? moment(dateAdded) : null,
    dateOfBirth: dateOfBirth ? moment(dateOfBirth) : null,
    dateUpdated: dateUpdated ? moment(dateUpdated) : null,
    emailConfirm,
    hasCoupon: !!coupon,
    lastTransition: lastTransition ? moment(lastTransition) : null,
    partner: partner ? partner.id : null,
    payments: Immutable.Set(payments.map(payment => payment.payment.reference)),
    preferredAppointmentDate: preferredAppointmentDate ? moment(preferredAppointmentDate) : null,
    preferredAppointmentTime,
    qualification: qualification ? qualification.id : null,
    stateTransitions,
    token: token ? token.uuid : null,
    user: user ? user.id : null,
    ...signup,
  })
}

export function filterSignup(signup, filter) {
  let ok = true

  if (filter.state) {
    ok = filter.state.indexOf(signup.state) !== -1
  }

  if (filter.reference) {
    ok = signup.reference === filter.reference
  }

  return ok
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Signup.js